module.exports = __webpack_public_path__ + "img/avocado.ad9d4a14.png";